import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static get targets() {
    return ['form', 'email', 'submit', 'message']
  }

  connect() {
    this.isSubmitting = false
    // Bind methods to preserve 'this' context
    this.boundBeforeSubmit = this.beforeSubmit.bind(this)
    this.boundOnSuccess = this.onSuccess.bind(this)
    this.boundOnError = this.onError.bind(this)

    // Add event listeners (removed passive: true to allow preventDefault)
    this.formTarget.addEventListener('ajax:before', this.boundBeforeSubmit)
    this.formTarget.addEventListener('ajax:success', this.boundOnSuccess)
    this.formTarget.addEventListener('ajax:error', this.boundOnError)
  }

  beforeSubmit(event) {
    if (this.isSubmitting) {
      event.preventDefault()
      return false
    }
    this.isSubmitting = true

    // Minimal DOM updates for performance
    this.submitTarget.classList.add('loading')
    this.submitTarget.textContent = 'Subscribing...'
    this.submitTarget.disabled = true
    this.messageTarget.style.display = 'none'
  }

  onSuccess(event) {
    this.showMessage(event.detail[0].message, 'success')
    this.emailTarget.value = ''
    this.resetButton()
  }

  onError(event) {
    this.showMessage(event.detail[0]?.message || 'Please try again.', 'error')
    this.resetButton()
  }

  showMessage(text, type) {
    // Use Bootstrap alert classes to match giveaway success message styling
    const alertClass = type === 'success' ? 'alert-success' : 'alert-danger'

    this.messageTarget.innerHTML = `
      <div class="alert ${alertClass} alert-dismissible" role="alert">
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        ${text}
      </div>
    `
    this.messageTarget.style.display = 'block'

    // Cleanup with requestAnimationFrame for smooth performance
    this.hideTimeout = window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        this.messageTarget.style.display = 'none'
      })
    }, 3000)
  }

  resetButton() {
    this.isSubmitting = false
    this.submitTarget.classList.remove('loading')
    this.submitTarget.textContent = 'Subscribe'
    this.submitTarget.disabled = false
  }

  disconnect() {
    // Remove event listeners to prevent memory leaks
    if (this.formTarget) {
      this.formTarget.removeEventListener('ajax:before', this.boundBeforeSubmit)
      this.formTarget.removeEventListener('ajax:success', this.boundOnSuccess)
      this.formTarget.removeEventListener('ajax:error', this.boundOnError)
    }

    // Cleanup timeout on disconnect
    if (this.hideTimeout) {
      window.clearTimeout(this.hideTimeout)
    }
  }
}
